'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var debug = require('debug')('knack-field-predictor-core');
var FieldPredictor = require('./predictor');
var ColumnTypeInference = /*#__PURE__*/function () {
  function ColumnTypeInference() {
    _classCallCheck(this, ColumnTypeInference);
    debug('ColumnTypeInference initialized.');
  }

  // eslint-disable-next-line class-methods-use-this
  return _createClass(ColumnTypeInference, [{
    key: "detectPossibleMultipleChoiceColumns",
    value: function detectPossibleMultipleChoiceColumns(data) {
      var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
      var uniqueValuesPerColumn = Array(data[0].length).fill(null).map(function () {
        return new Set();
      });
      var valueCountsPerColumn = Array(data[0].length).fill(null).map(function () {
        return new Map();
      });
      var hasLongValuePerColumn = Array(data[0].length).fill(false); // Track if a column has a long value

      data.forEach(function (row) {
        row.forEach(function (value, columnIndex) {
          if (typeof value === 'string') {
            var trimmedValue = value.trim();

            // If a long value is found, mark the column and skip further processing for that value
            if (trimmedValue.length > 50) {
              hasLongValuePerColumn[columnIndex] = true;
              return;
            }
            if (trimmedValue !== '') {
              uniqueValuesPerColumn[columnIndex].add(trimmedValue);

              // Count occurrences of each value
              var countMap = valueCountsPerColumn[columnIndex];
              countMap.set(trimmedValue, (countMap.get(trimmedValue) || 0) + 1);
            }
          }
        });
      });
      return uniqueValuesPerColumn.map(function (uniqueValues, columnIndex) {
        // If a long value exists in this column, it cannot be multiple_choice
        if (hasLongValuePerColumn[columnIndex]) {
          return false;
        }
        var uniqueCount = uniqueValues.size;
        if (uniqueCount === 0 || uniqueCount > threshold) {
          return false;
        }

        // Count how many values have appeared at least twice
        var repeatedValuesCount = Array.from(valueCountsPerColumn[columnIndex].values()).filter(function (count) {
          return count >= 2;
        }).length;

        // Ensure there are at least two values that appear at least twice
        return repeatedValuesCount >= 2;
      });
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getMostCommonTypesByColumn",
    value: function getMostCommonTypesByColumn(rowTypes) {
      var headerRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var counters = Array(rowTypes[0].length).fill(null).map(function () {
        return {};
      });
      rowTypes.forEach(function (row) {
        row.forEach(function (_ref, columnIndex) {
          var type = _ref.type,
            format = _ref.format;
          // to avoid the problem when empty values dominates non-empty, i.e numbers being predicted as short_text
          if (type === 'no_prediction') {
            return;
          }
          var typeFormatKey = "".concat(type, "|").concat(JSON.stringify(format) || '');
          if (!counters[columnIndex][typeFormatKey]) {
            counters[columnIndex][typeFormatKey] = {
              count: 0,
              format: format
            };
          }
          counters[columnIndex][typeFormatKey].count += 1;
        });
      });
      return counters.map(function (counter, columnIndex) {
        var _mostCommonTypeFormat;
        var header = (headerRow === null || headerRow === void 0 ? void 0 : headerRow[columnIndex]) || '';
        if (header && /status/i.test(header)) {
          debug("Column ".concat(columnIndex, " is a status column."));
          return {
            type: 'multiple_choice',
            format: ''
          };
        }
        var maxCount = 0;
        var mostCommonTypeFormat = null;
        Object.entries(counter).forEach(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            _ref3$ = _ref3[1],
            count = _ref3$.count,
            format = _ref3$.format;
          if (count > maxCount) {
            maxCount = count;
            var _key$split = key.split('|'),
              _key$split2 = _slicedToArray(_key$split, 1),
              type = _key$split2[0];
            mostCommonTypeFormat = {
              type: type,
              format: format
            };
          }
        });
        if (((_mostCommonTypeFormat = mostCommonTypeFormat) === null || _mostCommonTypeFormat === void 0 ? void 0 : _mostCommonTypeFormat.type) === 'boolean') {
          var totalValuesCount = rowTypes.length;
          if (maxCount !== totalValuesCount) {
            // If the number of boolean predictions does not match the total number of values then it is not boolean
            mostCommonTypeFormat.type = 'short_text';
          }
        }
        // If no prediction was counted (I mean, all were 'no_prediction'),
        // default to 'short_text' instead.
        if (!mostCommonTypeFormat) {
          mostCommonTypeFormat = {
            type: 'short_text',
            format: ''
          };
        }
        debug("Column ".concat(columnIndex, " is most likely ").concat(mostCommonTypeFormat.type, " with format ").concat(mostCommonTypeFormat.format));
        return mostCommonTypeFormat;
      });
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "predictFieldType",
    value: function predictFieldType(value) {
      var prediction = {
        type: 'no_prediction',
        format: ''
      };
      if (value) {
        var predictionResult = FieldPredictor.predict(value);
        if (predictionResult !== null && predictionResult !== void 0 && predictionResult.type) {
          var type = predictionResult.type,
            format = predictionResult.format;
          prediction = {
            type: type === 'link:url' ? 'link' : type,
            format: format
          };
        }
      }
      return prediction;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getUniqueOptionsForMultipleChoice",
    value: function getUniqueOptionsForMultipleChoice(rows, numColumn) {
      var uniqueStatus = new Set();
      var defaultOptions = ['First Choice', 'Second Choice', 'Third Choice'];
      debug(" processing Column ".concat(numColumn, " ."));
      rows.forEach(function (row) {
        if (row[numColumn]) {
          uniqueStatus.add(row[numColumn]);
        }
      });
      return {
        blank: 'Select...',
        "default": 'kn-blank',
        sorting: 'alphabetical',
        type: 'single',
        options: _toConsumableArray(uniqueStatus.size > 0 ? uniqueStatus : defaultOptions)
      };
    }

    /**
    * Predicts the data types for each column in a given dataset.
    *
    * @param {Array<Array<any>>} data - A two-dimensional array where each inner array represents a row of data.
    * @param {Array<string>} [headerRow=[]] - An optional array representing the column headers.
    * @returns {Array<Object>} An array where each object represents the predicted field type for a column.
    * Each object has the following structure:
    *   {
    *     type: string,    // The predicted type ('short_text', 'number', 'boolean', 'currency', etc.)
    *     format?: object  // Additional format metadata (e.g., for 'multiple_choice' fields)
    *   }
    *
    */
  }, {
    key: "getColumnTypes",
    value: function getColumnTypes(data) {
      var _this = this;
      var headerRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var multipleChoiceOptionsThreshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
      if (!data.length) return [];
      var rowTypes = data.map(function (row) {
        return row.map(function (value) {
          return _this.predictFieldType(value);
        });
      });
      var predictedFieldTypes = this.getMostCommonTypesByColumn(rowTypes, headerRow);
      var limitedUniqueColumns = this.detectPossibleMultipleChoiceColumns(data, multipleChoiceOptionsThreshold);
      predictedFieldTypes.forEach(function (field, index) {
        if (field.type === 'short_text' && limitedUniqueColumns[index]) {
          // eslint-disable-next-line no-param-reassign
          field.type = 'multiple_choice';
        }
        if (field.type === 'multiple_choice') {
          var multipleChoiceFormat = _this.getUniqueOptionsForMultipleChoice(data, index);
          // eslint-disable-next-line no-param-reassign
          field.format = multipleChoiceFormat;
        }
      });
      return predictedFieldTypes;
    }
  }]);
}();
module.exports = new ColumnTypeInference();